import { AdditionalCostRestEndpointService } from '@api'
import { useMutation, useQueryClient } from 'react-query'

import { useToast } from '@/components/ui/toast.tsx'
import type { AccountingCostBody } from '@/modules/accounting/types.ts'
import { handleError } from '@/utils/error'

export function useUpdateAdditionalCost() {
  const toast = useToast()
  const queryClient = useQueryClient()

  const updateCostMutation = useMutation(
    (
      body: Partial<AccountingCostBody> & {
        id: number
      },
    ) =>
      AdditionalCostRestEndpointService.dashboardUpdateAdditionalCost({
        requestBody: {
          amount: body.amount,
          name: body.name,
          typeId: body.typeId,
          valid: body.valid,
          retention: body.retention,
        },
        costId: body.id,
      }),
    {
      onSuccess: () => {
        toast.success('Additional cost successfully updated')
        queryClient.refetchQueries(['additional-costs'])
      },
      onError: (error) => {
        handleError(
          error,
          'Error occurred while updating cost, please try again',
        )
      },
      onSettled: () => {
        queryClient.invalidateQueries(['accounting_data'])
      },
    },
  )

  const updateCost = (body: Partial<AccountingCostBody> & { id: number }) => {
    return updateCostMutation.mutateAsync(body)
  }

  return {
    updateCost,
    isLoading: updateCostMutation.isLoading,
  }
}
